import { EyeCatching } from '@/api/types'
import { FC } from 'react'
import Avatar from '@/components/Avatar'

type Props = {
  avatar: EyeCatching
  name: string
  body: string
}

const Component: FC<Props> = ({ avatar, name, body }) => {
  return (
    <div className="w-full bg-primary-50 flex flex-col md:flex-row p-4 items-center gap-4 rounded-[4px]">
      <div className="w-24 h-24 aspect-square flex items-center justify-center">
        <Avatar size="w=96&h=96" url={avatar.url} />
      </div>
      <div className="flex flex-col items-center md:items-start gap-4">
        <p className="text-lg">{name}</p>
        <p>{body}</p>
      </div>
    </div>
  )
}

export default Component
